import { NOT_FOUND, FORBIDDEN } from '../constants/httpStatusCodes'
import { getErrorAction } from './errorMapper'
import { NOT_FOUND_TYPES_PROJECT } from '../constants/notFoundTypes'
import { ERROR_MESSAGE_TYPE_BOARD_PERMSSIONS } from '../constants/errorMessageTypes'
import { redirectToNotFound } from './redirectToNotFound'
import { redirectToError } from './redirectToError'
import { createReducer } from './reducerUtils'
import { mergeMap, map, catchError } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'

// Actions
export const PROJECT_MEMBERS_LOAD = 'PROJECT_MEMBERS_LOAD'
export const PROJECT_MEMBERS_LOAD_SUCCESS = 'PROJECT_MEMBERS_LOAD_SUCCESS'
export const PROJECT_MEMBERS_LOAD_FAILURE = 'PROJECT_MEMBERS_LOAD_FAILURE'

// Action Creators
export const projectMembersLoad = projectId => ({ type: PROJECT_MEMBERS_LOAD, payload: projectId })
export const projectMembersLoadSuccess = (payload) => ({ type: PROJECT_MEMBERS_LOAD_SUCCESS, payload })
export const projectMembersLoadFailure = payload => ({ type: PROJECT_MEMBERS_LOAD_FAILURE, payload, error: true })

// Epics
export const projectMembersLoadEpic = (action$, state$, { vapiClient }) =>
  action$.pipe(
    ofType(PROJECT_MEMBERS_LOAD),
    mergeMap(action =>
      vapiClient.getProjectMembers(action.payload).pipe(
        map(ajaxResponse => projectMembersLoadSuccess(ajaxResponse.response)),
        catchError(error => of(getErrorAction(error, projectMembersLoadFailure)))
      )
    )
  )

export const projectMembersLoadFailureEpic = (action$, state$) =>
  action$.pipe(
    ofType(PROJECT_MEMBERS_LOAD_FAILURE),
    map(action => {
      switch (action.payload.status) {
        case NOT_FOUND:
          return redirectToNotFound(NOT_FOUND_TYPES_PROJECT)
        case FORBIDDEN:
          return redirectToError(ERROR_MESSAGE_TYPE_BOARD_PERMSSIONS)
        default:
          return redirectToError()
      }
    })
  )

// Reducer
const projectMembersLoadReducer = (state, members) => members

const projectMembersHandlerMapping = {
  [PROJECT_MEMBERS_LOAD_SUCCESS]: projectMembersLoadReducer
}

const projectMembersInitialState = null
export const projectMembersReducer = createReducer(projectMembersInitialState, projectMembersHandlerMapping)

export default projectMembersReducer



// WEBPACK FOOTER //
// ./src/store/projectMembers.js